import { createStore } from 'vuex';
import { survey } from './modules/survey';
import { ui } from './modules/ui';
import { kosapo } from './modules/kosapo';
import { interactive } from './modules/interactive';
import { knowledge } from './modules/knowledge';
import { settings } from './modules/settings';

export default createStore({
  state: {
    system: {
      appName: 'Soluto',
      version: ''
    },
    transactionId: '',
    isLoading: false
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    settings,
    knowledge,
    survey,
    ui,
    interactive,
    kosapo
  }
});
